import styled from 'styled-components';
import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';

export const TreeContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.grey[400]};
  border-radius: 4px;
  padding: 8px;
  max-height: 300px;
  overflow-y: auto;
`;

export const FolderItem = styled.div<{ $depth: number }>`
  display: flex;
  align-items: center;
  padding-left: ${({ $depth }) => 8 + $depth * 24}px;
  cursor: pointer;
`;

export const FolderItemContent = styled.div<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
  margin: 4px 0;
  background: ${({ $selected, theme }) => ($selected ? theme.tint.primary.light : 'transparent')};

  &:hover {
    background: ${({ $selected, theme }) => ($selected ? theme.tint.primary.medium : theme.palette.action.hover)};
  }
`;

export const ExpandIcon = styled.div<{ $visible: boolean; $expanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $visible }) => ($visible ? '24px' : '0')};
  height: ${({ $visible }) => ($visible ? '24px' : '0')};
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  color: ${({ theme }) => theme.palette.text.secondary};
  transform: rotate(${({ $expanded }) => ($expanded ? '-180deg' : '0deg')});
  transition: transform 0.2s ease;
`;

export const FolderName = styled.span<{ $selected: boolean }>`
  font-size: 14px;
  color: ${({ $selected, theme }) => ($selected ? theme.palette.primary.main : theme.palette.common.black)};
  margin-left: 8px;
`;

export const FolderPath = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.text.secondary};
  margin: 0;
`;

export const StyledSelectedFolderIcon = styled(FolderOpenIcon)`
  color: ${({ theme }) => theme.palette.primary.light};
`;

export const StyledDefaultFolderIcon = styled(FolderIcon)`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const StyledPickerPath = styled(FolderPath)`
  margin-top: ${({ theme }) => theme.spacing(1)};
`;
